import { DivisaoHonrariosDTO } from "./divisao-honorarios.model";
import { Pagar } from "./pagar.model";
import { Receber } from "./receber.model";

export class ReceberDivisaoHonorarios {
    Id: number;
    Numero: string;
    Parcela: string;
    Participante: string;
    Vencimento: string;
    Valor: number;
    Desconto: number;
    JurosAtraso: number;
    JurosFinanciamento: number;
    TaxaCartao: number;
    DataRecebimento: string;
    ValorRecebido: number;
    CreditoCliente: boolean;
    AcordoTrabalhista: boolean;
    Historico: string;
    CodigoCompleto: string;
    ExibirHistorico: boolean;
    TotalItens: number;

}

export class PagarDivisaoHonorarios{
    Id: number;
    Parcela: string;
    Emissao: Date;
    Numero: string; 
    Participante: string; 
    Desconto: string;
    Vencimento: Date;
    Valor: number;
    ValorAnterior: number;
    JurosAtraso: number;
    TaxaCartao: number;
    UsuarioPagamento?: number;
    DataPagamento?: Date;
    ValorPago: number;
    PagamentoLiberado: boolean;
    ExibirHistorico: boolean;
}

export class ParticipanteDivisao {
    Id: number;
    NomeFantasia: string;
    ValorPercentual: number;
    TipoDRId: number;
}

export class DetalharDivisaoHonorario {
    DivisaoID: number = 0;
    ListaAdvogados: ParticipanteDivisao[] = [];
    Cliente: ParticipanteDivisao = new ParticipanteDivisao();
    ListaReceber: ReceberDivisaoHonorarios[] = [];
    ListaPagar: PagarDivisaoHonorarios[] = [];
    CamposEditaveisDetalhamento: CamposEditaveisDetalhamento = new CamposEditaveisDetalhamento();
    // TipoDRReceberCliente?: number;
    // TipoDRPagarCliente?: number;
    // TipoDRReceberEscritorio?: number;
    // TipoDRSubstabelecido?: number;
    // TipoDREncaminhador?: number;
    // TipoDRAdvogados?: AdvogadosEdicaoDivisao[] = []; // 
    // Observacao?: string;
    // VencimentoInicial?: Date;
    // PrestacaoDeContas?: boolean;
    // AcordoTrabalhista?: boolean;

}

export class VincularDivisaoInput{
    ProcessoId: number;
    ClienteId: number;
    EscritorioPercentual: number;
    ClientePercentual: number;
    SubstabelecidoPercentual: number;
    DespesaPercentual: number;
    MapStringAdvogadosHonorarios: string;
    AdvogadosHonorarios: Map<number, number> = new Map();
    ReceberLista: any[] = [];
    PagarLista: any[] = [];
}
export class TitulosVinculadosProcesso{
    ListaReceber: any[] = [];
    ListaPagar: any[] = [];
}

export class EdicaoDivisaoHonorarioInput{

    DivisaoId: number;
    ValorTotal: string;
    TipoDRReceberCliente: number;
    TipoDRPagarCliente: number;
    TipoDRReceberEscritorio: number;
    TipoDRSubstabelecido: number;
    TipoDREncaminhador: number;
    Advogados: AdvogadosEdicaoDivisao[] = [];
    Observacao: string;
    VencimentoInicial: string;
    PrestacaoDeContas: boolean;
    AcordoTrabalhista: boolean;
    Ficha: string;
}

export class AdvogadosEdicaoDivisao {
    NomeFantasia: string;
    AdvogadoId: number;
    Id: number;
    TipoDRId: number;
    Percentual: number;
}

export class CamposEditaveisDetalhamento{
    ValorTotal: string;
    TipoDRReceberCliente: number;
    TipoDRPagarCliente: number;
    TipoDRReceberEscritorio: number;
    TipoDRSubstabelecido: number;
    TipoDREncaminhador: number;
    Advogados: AdvogadosEdicaoDivisao[] = [];
    Observacao: string;
    VencimentoInicial: Date;
    PrestacaoDeContas: boolean;
    AcordoTrabalhista: boolean;
}
